<div>
  <app-module-summary-bar [moduleTitle]="'COLLECTION MANAGEMENT'" [showPrimary]="usuario.hasPermission('oilRecovery', 'create')"
    [showSecondary]="usuario.hasPermission('oilRecovery', 'addRoute')"
    [showTertiary]="usuario.hasPermission('oilRecovery', 'generateOilCollectionsReport')" [autoLoadDashboard]="true"
    [primaryLabel]="'Add Record'" [secondaryLabel]="'Add Route'" [tertiaryLabel]="'Generate Collection Report'"
    (primaryClick)="openCollectionModal()" (secondaryClick)="openAddRouteModal()"
    (tertiaryClick)="openExportOilCollectionsReportExcel()"></app-module-summary-bar>

  <div class="hidden xl:flex row mb-2 mt-4">
    <div class="col-md-6">
      <div class="btn-group align-items-center" role="group" style="width: 100%;">
        <div style="min-width: 600px; max-width: 100%;">
          @if (viewMode === ViewMode.COLLECTIONS) {
            <app-search-input [placeholder]="'Business ID, Name, Address …'" (searchChange)="onTabletSearch($event)"></app-search-input>
          } @else if (viewMode === ViewMode.ROUTES) {
            <app-search-input [placeholder]="'Search by Route ID or Driver...'" (searchChange)="onRouteSearch($event)"></app-search-input>
          }
        </div>
      </div>
    </div>

    <div class="col-md-6 d-flex justify-content-end align-items-center filters-toolbar">
      <div class="view-toolbar-actions d-flex align-items-center" style="gap: 12px;">
        @if (viewMode === ViewMode.COLLECTIONS) {
          <app-date-filter (filterChange)="onDateFilterChange($event)"></app-date-filter>
          <app-filter-by [options]="filter_options" [value]="selected_values.length > 0 ? selected_values[0].value : 'all'" (filterChange)="onStatusFilter($event)"></app-filter-by>
          <button
            *appHasPermission="['oilRecovery', 'generateOilCollectionsReport']"
            class="btn btn-sm d-flex align-items-center gap-1"
            style="background-color: #217346; color: white; box-shadow: none !important; border: none; white-space: nowrap; border-radius: 8px; font-size: 13px; padding: 5px 12px;"
            title="Export current date filter as Excel"
            [disabled]="loadingExport()"
            (click)="exportCollections()">
            @if (loadingExport()) {
              <span class="spinner-border spinner-border-sm" role="status"></span>
            } @else {
              <i class="fa fa-file-excel-o"></i>
            }
            Export Excel
          </button>
        } @else if (viewMode === ViewMode.ROUTES) {
          <app-date-filter (filterChange)="onRouteDateFilterChange($event)"></app-date-filter>
        }
        
        <div class="view-switcher rounded-lg" role="group" aria-label="Toggle view mode">
          <button type="button" class="view-switcher__btn" [class.view-switcher__btn--active]="viewMode === ViewMode.COLLECTIONS" (click)="toggleView(ViewMode.COLLECTIONS)" title="Collections View">
            <i class="fa fa-tint"></i><span>Collections</span>
          </button>
          <button type="button" class="view-switcher__btn" [class.view-switcher__btn--active]="viewMode === ViewMode.ROUTES" (click)="toggleView(ViewMode.ROUTES)" title="Routes View">
            <i class="fa fa-road"></i><span>Routes</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="xl:hidden flex flex-row items-center gap-2 mb-2 px-1 mt-3">
    <div class="flex-1 min-w-0">
      @if (viewMode === ViewMode.COLLECTIONS) {
        <app-tablet-search [placeholder]="'Search Business...'" (searchChange)="onTabletSearch($event)"></app-tablet-search>
      } @else if (viewMode === ViewMode.ROUTES) {
        <app-tablet-search [placeholder]="'Search by Route ID...'" (searchChange)="onRouteSearch($event)"></app-tablet-search>
      }
    </div>
    @if (viewMode === ViewMode.COLLECTIONS) {
      <app-tablet-date-filter (filterChange)="onDateFilterChange($event)" class="shrink-0"></app-tablet-date-filter>
      <app-tablet-status-filter [options]="filter_options" [selectedValues]="selected_values" (valuesChange)="onStatusFilter($event)" class="shrink-0"></app-tablet-status-filter>
    } @else if (viewMode === ViewMode.ROUTES) {
      <app-tablet-date-filter (filterChange)="onRouteDateFilterChange($event)" class="shrink-0"></app-tablet-date-filter>
    }

    <!-- View Switcher for Tablet/Mobile -->
    <div class="view-switcher rounded-lg shrink-0" role="group" aria-label="Toggle view mode">
      <button type="button" class="view-switcher__btn" [class.view-switcher__btn--active]="viewMode === ViewMode.COLLECTIONS" (click)="toggleView(ViewMode.COLLECTIONS)" title="Collections View">
        <i class="fa fa-tint"></i><span class="d-none d-md-inline ms-1">Collections</span>
      </button>
      <button type="button" class="view-switcher__btn" [class.view-switcher__btn--active]="viewMode === ViewMode.ROUTES" (click)="toggleView(ViewMode.ROUTES)" title="Routes View">
        <i class="fa fa-road"></i><span class="d-none d-md-inline ms-1">Routes</span>
      </button>
    </div>
  </div>

  @if (viewMode === ViewMode.COLLECTIONS) {

      <div class="animated fadeIn mt-1 position-relative">
        <!-- Tier 8: el bloque <wj-flex-grid> + <app-custom-paginator> con `*ngIf="false"`
             y el <div [hidden]="true"> del flexclone/wj-collection-view-navigator
             fueron eliminados. Ahora solo se renderiza <app-kite-grid>. -->
        <app-kite-grid
          [columnDefs]="collectionsColumnDefs"
          [rowData]="collectionsRowData()"
          [loading]="loadingTable()"
          [gridOptions]="collectionsGridOptions"
          [totalRecords]="totalRecords()"
          [pageSize]="pageSize"
          (pageChange)="onCollectionsPageChange($event)">
        </app-kite-grid>
      </div>
  } @else if (viewMode === ViewMode.ROUTES) {

      <div class="animated fadeIn mt-1 position-relative">
        <!-- Tier 8: bloque <wj-flex-grid> + paginator con *ngIf="false" eliminado. -->
        <app-kite-grid
          [columnDefs]="routesColumnDefs"
          [rowData]="routesRowData()"
          [loading]="loadingRoutesTable()"
          [gridOptions]="routesGridOptions"
          [totalRecords]="totalRoutesRecords()"
          [pageSize]="routePageSize"
          (pageChange)="onRoutesPageChange($event)">
        </app-kite-grid>
      </div>
  }
</div>

@if (loading()) {
  <app-page-loading [absolute]="true"></app-page-loading>
}